














import { Component, Prop, Vue } from 'vue-property-decorator';
import Popup from '@/components/default/Popup.vue';
import moment from 'moment';

@Component({
  components: {
    Popup,
  },
})
export default class MarkMeasuringStateLinesCompletedDialog extends Vue {
  @Prop()
  allowPreviousMonthCompletion!: boolean;
  show: boolean = false;
  saving: boolean = false;
  dates: any[] = [];
  selectedDate: Date | null = null;

  public open() {
    this.show = true;

    this.setDates();
  }

  public closed() {
    this.selectedDate = null;
    this.show = false;
  }

  public save() {
    if (!this.selectedDate) {
      return;
    }

    this.$emit('save', this.selectedDate);
    this.closed();
  }

  private setDates() {
    const previousMonth = moment().subtract('1', 'month').set('date', 15);
    const thisMonth = moment().set('date', 15);

    this.dates = [
      {
        value: thisMonth.toDate(),
        text: thisMonth.locale('nl-BE').format('MMMM yyyy'),
      },
    ];

    if (this.allowPreviousMonthCompletion) {
      this.dates.push({
        value: previousMonth.toDate(),
        text: previousMonth.locale('nl-BE').format('MMMM yyyy'),
      });
    }
  }
}
